import { createSlice } from '@reduxjs/toolkit';
import VwHbsIslemtanimDTO from 'src/models/GenelTanimlar/VwHbsIslemtanimDTO';
import VwHbsOrderAmeliyatDTO from 'src/models/Order/Ameliyat/VwHbsOrderAmeliyatDTO';
import HbsOrderDetayDTO from 'src/models/Order/HbsOrderDetayDTO';
import VwOrderGrupIlaclarDTO from 'src/models/Order/Ilac/VwOrderGrupIlaclarDTO';
import VwOrderGrupMuadilIlaclarDTO from 'src/models/Order/Ilac/VwOrderGrupMuadilIlaclarDTO';
import VwHbsOrderKonsultasyonDTO from 'src/models/Order/Konsultasyon/VwHbsOrderKonsultasyonDTO';
import OrderIlacWrapper from 'src/models/Order/OrderIlacWrapper';
import VwHbsOrderPatolojiDTO from 'src/models/Order/Patoloji/VwHbsOrderPatolojiDTO';
import VwHbsOrderDTO from 'src/models/Order/VwHbsOrderDTO';
import VwHbsOrderIlacDTO from 'src/models/Order/VwHbsOrderIlacDTO';
import VwHbsOrderListeDTO from 'src/models/Order/VwHbsOrderListeDTO';
import VwHbsOrderPatolojitestDTO from 'src/models/PatolojiModul/VwHbsOrderPatolojitestDTO';
import VwIslemaramaAutocompleteDTO from 'src/models/PatolojiModul/VwIslemaramaAutocompleteDTO';
import VwStkAraDTO from 'src/models/StokEczane/StokDurum/VwStkAraDTO';
import { IKeyValue } from 'src/models/store/IKeyValue';
import MapReducerPayloads from 'src/models/store/MapReducerPayloads';
import { VwStokaraRequest } from 'src/services/StokEczane/StokDurumApi';
import { helper } from 'src/utils/helper';

export const aktifGruplar: IKeyValue[] = [
  { key: 1, value: 'Tüm Zamanlar' },
  { key: 2, value: 'Aktif Müracaat' },
  { key: 3, value: 'Aktif Servis' },
  { key: 4, value: 'Bugüne Ait Kayıtlar' },
  { key: 5, value: 'Son 10 Gün' },
  { key: 6, value: 'Tarih Seçiniz' }
];
export class OrderAramaModel {
  baslangicTarih: string = helper.datetimeToday();
  bitisTarih: string = helper.datetimeToday();
  grupId: string = '';
  aktifGrupId: number = 4;
  hastaservisId: number = null;
  kimlikId: number = null;
  muracaatId: number = null;
  bagliOrganizasyonId: number = null;
}
export interface IOrderState {
  aramaModel: OrderAramaModel;
  tabState: number;
  open: boolean;
  order: VwHbsOrderDTO;
  orderDetaylar: HbsOrderDetayDTO[];
  orderDetay: HbsOrderDetayDTO;
  orderPatoloji: VwHbsOrderPatolojiDTO;
  orderAmeliyat: VwHbsOrderAmeliyatDTO;
  orderIlacOpen: boolean;
  oderDepoDurumFilter: VwStokaraRequest;
  orderIlacSecilenRow: VwHbsOrderIlacDTO[];
  orderIlacGruptanSecilenRow: VwHbsOrderIlacDTO[];
  orderIlacGruptanSecilenTempRow: OrderIlacWrapper[];
  orderIlacDepodanSecilenRow: VwHbsOrderIlacDTO[];
  orderIlacDisTeminSecilenRow: VwHbsOrderIlacDTO[];
  orderIlacMuadilSecilenRow: VwHbsOrderIlacDTO[];
  orderIlacGrupRowModel: OrderIlacWrapper[];
  orderIlacDepoRowModel: VwStkAraDTO[];
  orderIlacDisTeminRowModel: VwStkAraDTO[];
  orderIlacMuadilRowModel: VwOrderGrupMuadilIlaclarDTO[];
  orderIlacOnay: boolean;
  orderKonsultasyon: VwHbsOrderKonsultasyonDTO;
  orderPatolojiTest: Array<VwHbsOrderPatolojitestDTO>;
  islemList: Array<VwIslemaramaAutocompleteDTO>;
  islemSec: Array<VwHbsIslemtanimDTO>;
  orderListe: VwHbsOrderListeDTO;
  orderId: number
}
const OrderSlice = createSlice<
  IOrderState,
  MapReducerPayloads<
    IOrderState,
    {
      setState: IOrderState;
      setAramaModel: OrderAramaModel;
      setTabState: number;
      setOpen: boolean;
      setOrder: VwHbsOrderDTO;
      setOrderDetay: HbsOrderDetayDTO;
      setOrderPatoloji: VwHbsOrderPatolojiDTO;
      setOrderAmeliyat: VwHbsOrderAmeliyatDTO;
      setOrderDepoDurumFilter: VwStokaraRequest;
      setOrderIlacSecilenRow: VwHbsOrderIlacDTO[];
      setOrderIlacGruptanSecilenRow: VwHbsOrderIlacDTO[];
      setOrderIlacGruptanSecilenTempRow: OrderIlacWrapper[];
      setOrderIlacDepodanSecilenRow: VwHbsOrderIlacDTO[];
      setOrderIlacDisTeminSecilenRow: VwHbsOrderIlacDTO[];
      setOrderIlacMuadilSecilenRow: VwHbsOrderIlacDTO[];
      setOrderIlacGrupRowModel: OrderIlacWrapper[];
      setOrderIlacDepoRowModel: VwStkAraDTO[];
      setOrderIlacDisTeminRowModel: VwStkAraDTO[];
      setOrderIlacMuadilRowModel: VwOrderGrupMuadilIlaclarDTO[];
      setOrderIlacOnay: boolean;
      setOrderDetaylar: HbsOrderDetayDTO[];
      setOrderKonsultasyon: VwHbsOrderKonsultasyonDTO;
      setOrderIlacOpen: boolean;
      setOrderPatolojiTest: Array<VwHbsOrderPatolojitestDTO>;
      setIslemList: Array<VwIslemaramaAutocompleteDTO>;
      setIslemSec: Array<VwHbsIslemtanimDTO>;
      setOrderListe: VwHbsOrderListeDTO;
      setOrderId: number
    }
  >
>({
  name: 'order',
  initialState: {
    aramaModel: new OrderAramaModel(),
    tabState: 6,
    open: false,
    order: new VwHbsOrderDTO(),
    orderDetay: new HbsOrderDetayDTO(),
    orderPatoloji: new VwHbsOrderPatolojiDTO(),
    orderAmeliyat: new VwHbsOrderAmeliyatDTO(),
    oderDepoDurumFilter: new VwStokaraRequest(),
    orderIlacSecilenRow: new Array<VwHbsOrderIlacDTO>(),
    orderIlacDepodanSecilenRow: new Array<VwHbsOrderIlacDTO>(),
    orderIlacGruptanSecilenRow: new Array<VwHbsOrderIlacDTO>(),
    orderIlacGruptanSecilenTempRow: new Array<OrderIlacWrapper>(),
    orderIlacDisTeminSecilenRow: new Array<VwHbsOrderIlacDTO>(),
    orderIlacMuadilSecilenRow: new Array<VwHbsOrderIlacDTO>(),
    orderIlacGrupRowModel: new Array<OrderIlacWrapper>(),
    orderIlacDepoRowModel: new Array<VwStkAraDTO>(),
    orderIlacDisTeminRowModel: new Array<VwStkAraDTO>(),
    orderIlacMuadilRowModel: new Array<VwOrderGrupMuadilIlaclarDTO>(),
    orderIlacOnay: false,
    orderDetaylar: [],
    orderKonsultasyon: new VwHbsOrderKonsultasyonDTO(),
    orderIlacOpen: false,
    orderPatolojiTest: new Array<VwHbsOrderPatolojitestDTO>(),
    islemList: new Array<VwIslemaramaAutocompleteDTO>(),
    islemSec: new Array<VwHbsIslemtanimDTO>(),
    orderListe: new VwHbsOrderListeDTO(),
    orderId: 0,
  },
  reducers: {
    setState: (state, action) => action.payload,
    setAramaModel: (state, action) => {
      state.aramaModel = action.payload;
    },
    setTabState: (state, action) => {
      state.tabState = action.payload;
    },
    setOpen: (state, action) => {
      state.open = action.payload;
    },
    setOrder: (state, action) => {
      state.order = action.payload;
    },
    setOrderDetay: (state, action) => {
      state.orderDetay = action.payload;
    },
    setOrderPatoloji: (state, action) => {
      state.orderPatoloji = action.payload;
    },
    setOrderAmeliyat: (state, action) => {
      state.orderAmeliyat = action.payload;
    },
    setOrderDepoDurumFilter: (state, action) => {
      state.oderDepoDurumFilter = action.payload;
    },
    setOrderIlacSecilenRow: (state, action) => {
      state.orderIlacSecilenRow = action.payload;
    },
    setOrderIlacDepodanSecilenRow: (state, action) => {
      state.orderIlacDepodanSecilenRow = action.payload;
    },
    setOrderIlacGruptanSecilenRow: (state, action) => {
      state.orderIlacGruptanSecilenRow = action.payload;
    },
    setOrderIlacGruptanSecilenTempRow: (state, action) => {
      state.orderIlacGruptanSecilenTempRow = action.payload;
    },
    setOrderIlacDisTeminSecilenRow: (state, action) => {
      state.orderIlacDisTeminSecilenRow = action.payload;
    },
    setOrderIlacMuadilSecilenRow: (state, action) => {
      state.orderIlacMuadilSecilenRow = action.payload;
    },
    setOrderIlacGrupRowModel: (state, action) => {
      state.orderIlacGrupRowModel = action.payload;
    },
    setOrderIlacDepoRowModel: (state, action) => {
      state.orderIlacDepoRowModel = action.payload;
    },
    setOrderIlacDisTeminRowModel: (state, action) => {
      state.orderIlacDisTeminRowModel = action.payload;
    },
    setOrderIlacMuadilRowModel: (state, action) => {
      state.orderIlacMuadilRowModel = action.payload;
    },
    setOrderIlacOnay: (state, action) => {
      state.orderIlacOnay = action.payload;
    },
    setOrderDetaylar: (state, action) => {
      state.orderDetaylar = action.payload;
    },
    setOrderKonsultasyon: (state, action) => {
      state.orderKonsultasyon = action.payload;
      state.orderKonsultasyon = action.payload;
    },
    setOrderIlacOpen: (state, action) => {
      state.orderIlacOpen = action.payload;
    },
    setOrderPatolojiTest: (state, action) => {
      state.orderPatolojiTest = action.payload;
    },
    setIslemList: (state, action) => {
      state.islemList = action.payload;
    },
    setIslemSec: (state, action) => {
      state.islemSec = action.payload;
    },
    setOrderListe: (state, action) => {
      state.orderListe = action.payload;
    },
    setOrderId: (state, action) => {
      state.orderId = action.payload;
    },
  }
});
export default OrderSlice;
